export function formatDateToYMD(date: Date): string {
    const year = date.getFullYear();
    // 월은 0부터 시작하므로 +1을 해준 뒤, 2자리로 맞춰줍니다.
    const month = String(date.getMonth() + 1).padStart(2, "0");
    // 날짜도 2자리로 맞춰줍니다.
    const day = String(date.getDate()).padStart(2, "0");
  
    return `${year}-${month}-${day}`;
  }